import '@styles/frontend/main.scss';
import { renderForm } from './render';
import { utmTracker } from './utm-tracking';
import { setLocalStorageFormFields } from './populate-local-storage';

export { setSubmitListeners } from './submit';

export const initLeadForms = (formsUrl = 'https://aquentllc.wpengine.com/') => {
  const renderFormElements = () => {
    const forms = document.querySelectorAll('div[data-leadform-id]:not([data-rendered])');
    const trimmedFormsUrl = formsUrl.replace(/\/$/, '');
    if (forms.length > 0) {
      forms.forEach((form) => {
        const formId = form.getAttribute('data-leadform-id') ?? 0;
        form.setAttribute('data-rendered', 'true');
        renderForm(form, formId, trimmedFormsUrl);
      });
    }
  };

  // Observe DOM changes to populate forms when they are injected
  const formInjectionObserver = new MutationObserver((mutations) => {
    let shouldCheckForms = false;

    for (const mutation of mutations) {
      // If nodes were added to the DOM
      if (mutation.addedNodes.length > 0) {
        shouldCheckForms = true;
        break; // Optimization: stop looping once we know we need to check
      }
    }

    if (shouldCheckForms) {
      // Look for any Gravity Forms that have been injected
      const forms = document.querySelectorAll('form[data-formid]');
      forms.forEach((form) => {
        // Run our population logic on every form found
        setLocalStorageFormFields(form);
      });
    }
  });

  // Start the Listeners
  renderFormElements();

  // Watch for the Container
  const containerObserver = new MutationObserver(renderFormElements);
  containerObserver.observe(document.body, { attributes: false, childList: true, subtree: true });

  // Watch for the Form (AJAX Injection)
  formInjectionObserver.observe(document.body, { attributes: false, childList: true, subtree: true });

  utmTracker();
};

initLeadForms(window.leadFormsUrl ?? 'https://aquentllc.wpengine.com/');
